export { settingsStore as store } from './store'



// WEBPACK FOOTER //
// ./src/settings/index.js